import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { coursesApi, liveCoursesApi } from "@/api";
import type { CourseFilter } from "@/api";
import { QUERY_KEYS } from "@/constants";

/** Yozib olingan kurs yoki jonli kurs — ro'yxat mantig'i ikkovida bir xil. */
export type CourseKind = "recorded" | "live";

/** "mine" — o'qituvchining o'zi yaratganlari, "all" — to'liq katalog. */
export type CourseScope = "mine" | "all";

/**
 * `type` — HAR DOIM yuboriladi. `/courses` turdan qat'i nazar hamma kursni
 * qaytaradi: ilgari "Kurslar" sahifasida jonli kurslar ham chiqar,
 * analitikadagi holatlar grafigi esa jonli kursni ikki marta sanardi.
 */
const SOURCES = {
  recorded: {
    api: coursesApi,
    type: "RECORDED",
    keys: { all: QUERY_KEYS.GET_COURSES, mine: QUERY_KEYS.GET_MY_COURSES },
  },
  live: {
    api: liveCoursesApi,
    type: "LIVE",
    keys: { all: QUERY_KEYS.GET_LIVE_COURSES, mine: QUERY_KEYS.GET_MY_LIVE_COURSES },
  },
} as const;

/**
 * Kurs ro'yxati — yozib olingan va jonli kurslar uchun bitta hook.
 *
 * Ilgari `useCourseList` va `useLiveCourseList` qatorma-qator bir xil edi.
 * Ikkita nusxa — ikkita joyda tuzatiladigan xato degani, shuning uchun
 * farqi (qaysi API, qaysi kalit) parametrga chiqarildi.
 */
export const useCourseListQuery = (
  kind: CourseKind,
  filter: CourseFilter,
  scope: CourseScope,
  enabled = true,
) => {
  const source = SOURCES[kind];
  const scoped: CourseFilter = { ...filter, type: source.type };

  return useQuery({
    queryKey: [scope === "all" ? source.keys.all : source.keys.mine, scoped],
    queryFn: () => (scope === "all" ? source.api.getAll(scoped) : source.api.getMy(scoped)),
    placeholderData: keepPreviousData,
    enabled,
    select: res => ({ rows: res.data, meta: res.meta }),
  });
};
